import type { TLAssetId } from "@tldraw/tlschema";

// Local URLs never enter the shared document. Explicit cleanup avoids SDK preview
// timers retaining an entire disposed editor until the preview timeout expires.
export class ImagePreviews {
  private urls = new Map<TLAssetId, string>();
  get(id: TLAssetId) {
    return this.urls.get(id) ?? null;
  }
  set(id: TLAssetId, blob: Blob) {
    this.remove(id);
    this.urls.set(id, URL.createObjectURL(blob));
  }
  remove(id: TLAssetId) {
    const url = this.urls.get(id);
    if (url) URL.revokeObjectURL(url);
    this.urls.delete(id);
  }
  clear() {
    for (const id of this.urls.keys()) this.remove(id);
  }
}
